import { useState } from "react";
import { fetchManuals } from "../api/fetchManuals";

export interface IAssetManuals {
    chassis?: string;
    year?: number;
    manuals?: { name: string; downloadLink: string }[],
}

function useAssetManuals() {
    const [assetManuals, setAssetManuals] = useState<IAssetManuals | null>(null);
    const [assetManualsLoading, setAssetManualsLoading] = useState(false);
    const [assetManualsDialog, setAssetManualsDialog] = useState(false);

    const [assetManualsChassis, setAssetManualsChassis] = useState<string>("");

    const getManuals = async (chassis: string) => {
        try {
            const manuals = await fetchManuals(chassis);
            setAssetManuals(manuals);
        } catch (error) {
            setAssetManuals(null);
        };
    }

    const handleAssetManualsSidebar = async (chassis: string) => {
        setAssetManualsChassis(chassis);
        setAssetManualsLoading(true);
        setAssetManualsDialog(true);

        await getManuals(chassis);

        setAssetManualsLoading(false);
    };
    
    const handleCloseAssetManualsSidebar = () => {
        setAssetManualsDialog(false);
        setAssetManuals(null);
        setAssetManualsChassis("");
    };

    return { assetManuals, handleAssetManualsSidebar, handleCloseAssetManualsSidebar, assetManualsDialog, assetManualsLoading, assetManualsChassis }
}

export default useAssetManuals;